import { useDispatch, useSelector } from 'react-redux';
import { GoLinkExternal } from 'react-icons/go';

import CustomButton from '../CustomButton';

import CONSTANTS from '../../utils/constants/CONSTANTS';

import { stripeConnectAsync } from '../../redux/user/UserAction';

const StripeConnectButton = () => {
  const dispatch = useDispatch();

  const isFetchingStripeConnectStatus = useSelector((state) => state.user.isFetchingStripeConnectStatus);
  const stripeConnectStatus = useSelector((state) => state.user.stripeConnectStatus);
  const isFetchingStripeConnectURL = useSelector((state) => state.user.isFetchingStripeConnectURL);

  // Early return if we have no status information
  if (!stripeConnectStatus) return null;

  const { stripe_connected: stripeConnected, express_dashboard_url: stripeDashboardUrl } = stripeConnectStatus;

  const handleStripeConnect = () => {
    // If fully connected with dashboard URL available, redirect to the URL
    if (stripeConnected && stripeDashboardUrl) {
      window.open(stripeDashboardUrl, '_blank');
    } else {
      // Otherwise, dispatch the connect action
      dispatch(stripeConnectAsync());
    }
  };

  // Determine button configuration based on connection state
  const buttonConfig = {
    type: CONSTANTS.STRIPE_CONNECT_TYPE,
    label: isFetchingStripeConnectURL ? 'Redirecting...' : 'Connect with stripe',
  };

  // If connected but dashboard URL not available
  if (stripeConnected && stripeDashboardUrl === null) {
    buttonConfig.label = isFetchingStripeConnectURL ? 'Redirecting...' : 'Continue connecting stripe';
  }

  // If fully connected with dashboard available
  if (stripeConnected && stripeDashboardUrl !== null) {
    buttonConfig.type = CONSTANTS.STRIPE_DASHBOARD;
    buttonConfig.label = isFetchingStripeConnectURL ? (
      'Redirecting...'
    ) : (
      <>
        Your Dashboard <GoLinkExternal />
      </>
    );
  }

  return (
    <CustomButton value="submit" type={buttonConfig.type} handleClick={handleStripeConnect}>
      {isFetchingStripeConnectStatus ? 'Loading stripe status...' : buttonConfig.label}
    </CustomButton>
  );
};

export default StripeConnectButton;
